export default "__VITE_ASSET__f6f6f3e5__"